
/**
 * 
 */
class WMUWCCart {

	/**
	 * 
	 * @type String
	 */
	actionAdd = '';

	/**
	 * 
	 * @type String
	 */
	actionRemove = '';

	/**
	 * 
	 * @type String
	 */
	actionSingleAdd = '';

	/**
	 * 
	 * @type String
	 */
	actionUpdate = '';

	/**
	 * 
	 * @type String
	 */
	actionUpdateCount = '';

	/**
	 * 
	 * @type Array
	 */
	addToCartButtonList = [];

	/**
	 * 
	 * @type String
	 */
	addToCartButtonAddedClass = 'is-added';

	/**
	 * 
	 * @type String
	 */
	addToCartButtonCallingClass = 'is-calling';

	/**
	 * 
	 * @type String
	 */
	addToCartButtonCheckClass = 'ajax_add_to_cart';

	/**
	 * 
	 * @type String
	 */
	addToCartButtonAncestorSelector = '.type-product';

	/**
	 * 
	 * @type String
	 */
	addToCartButtonSelector = '.ajax_add_to_cart';

	/**
	 * 
	 * @type String
	 */
	ajaxUrl = '';

	/**
	 * 
	 * @type String
	 */
	cartFormSelector = '.woocommerce-cart-form';

	/**
	 * 
	 * @type WMUWCPopin
	 */
	cartPopin = null;

	/**
	 * 
	 * @type String
	 */
	cartPopinId = 'wmuwc-cart-popin';

	/**
	 * 
	 * @type Boolean
	 */
	displayMiniCartOnAddProduct = true;

	/**
	 * 
	 * @type DOMParser
	 */
	domParser = null;

	/**
	 * 
	 * @type Boolean
	 */
	isCalling = false;

	/**
	 * 
	 * @type Boolean
	 */
	isCartPage = false;

	/**
	 * 
	 * @type Number
	 */
	itemCount = 0;

	/**
	 * 
	 * @type String
	 */
	miniCartFormSelector = '.wmuwc-mini-cart-wrapper .woocommerce-cart-form';

	/**
	 * 
	 * @type WMUWCPopin
	 */
	miniCartPopin = null;

	/**
	 * 
	 * @type String
	 */
	miniCartPopinId = 'wmuwc-minicart-popin';

	/**
	 * 
	 * @type String
	 */
	nonce = '';

	/**
	 * 
	 * @type Array
	 */
	openCartButtonList = [];

	/**
	 * 
	 * @type String
	 */
	openCartButtonSelector = ".wmu-open-cart";

	/**
	 * 
	 * @type String
	 */
	quantityInputSelector = '.quantity input';

	/**
	 * 
	 * @type String
	 */
	removeFromCartButtonClassCheck = 'remove_from_cart_button';

	/**
	 * 
	 * @type String
	 */
	removeFromCartButtonSelector = '.remove_from_cart_button';

	/**
	 * 
	 * @type String
	 */
	singleAddToCartFormSelector = 'form.cart';

	/**
	 * 
	 * @type HTMLElement
	 */
	updatedFormElement = null;

	/**
	 * 
	 * @type Number
	 */
	updateTimeoutDelay = 500;

	/**
	 * 
	 * @type Number
	 */
	updateTimeoutId = null;

	/**
	 * 
	 * @param {Object} args Expected properties : actionAdd (ajax action name), ajaxUrl (wordpress ajax URL) and nonce (nonce value)
	 */
	constructor( args )
	{
		this.actionAdd = args.actionAdd;
		this.actionRemove = args.actionRemove;
		this.actionSingleAdd = args.actionSingleAdd;
		this.actionUpdate = args.actionUpdate;
		this.actionUpdateCount = args.actionUpdateCount;
		this.ajaxUrl = args.ajaxUrl;
		this.displayMiniCartOnAddProduct = (
			args.displayMiniCartOnAddProduct == "1"
			|| args.displayMiniCartOnAddProduct == "true"
			|| args.displayMiniCartOnAddProduct == true
			|| args.displayMiniCartOnAddProduct == 1
			) ? true : false;
		this.isCartPage = (
			args.isCartPage == "1"
			|| args.isCartPage == "true"
			|| args.isCartPage == true
			|| args.isCartPage == 1
			) ? true : false;
		this.nonce = args.nonce;

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onAddToCartClick = this.onAddToCartClick.bind( this );
		this.onOpenCartClick = this.onOpenCartClick.bind( this );
		this.onQuantityChange = this.onQuantityChange.bind( this );
		this.onRemoveFromCartClick = this.onRemoveFromCartClick.bind( this );
		this.onSingleAddToCartFormSubmit = this.onSingleAddToCartFormSubmit.bind( this );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initAddToCartButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.addToCartButtonSelector ).forEach( ( element ) =>
		{
			if ( -1 === this.addToCartButtonList.indexOf( element ) )
			{
				element.addEventListener( 'click', this.onAddToCartClick );
				this.addToCartButtonList.push( element );
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement
	 */
	initOpenCartButtons( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.openCartButtonSelector ).forEach( ( element ) =>
		{
			if ( -1 === this.openCartButtonList.indexOf( element ) )
			{
				element.addEventListener( 'click', this.onOpenCartClick );
				this.openCartButtonList.push( element );
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initQuantityInputs( contextElement = null )
	{
		if ( null === contextElement && this.miniCartPopin )
		{
			contextElement = this.miniCartPopin.contentElement;
		}

		contextElement.querySelectorAll( this.quantityInputSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcCartInit )
			{
				element.addEventListener( 'change', this.onQuantityChange );
				element.wmuwcCartInit = true;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initRemoveFromCartButtons( contextElement = null )
	{
		if ( null === contextElement && this.miniCartPopin )
		{
			contextElement = this.miniCartPopin.contentElement;
		}

		contextElement.querySelectorAll( this.removeFromCartButtonSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcCartInit )
			{
				element.addEventListener( 'click', this.onRemoveFromCartClick );
				element.wmuwcCartInit = true;
			}
		} );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initSingleAddToCartForm( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = document.body;
		}

		contextElement.querySelectorAll( this.singleAddToCartFormSelector ).forEach( ( element ) =>
		{
			if ( ! element.wmuwcCartInit )
			{
				element.addEventListener( 'submit', this.onSingleAddToCartFormSubmit );
				element.wmuwcCartInit = true;
			}
		} );
	}

	/**
	 * 
	 * @param {Number} productId 
	 * @param {HTMLElement} elementCaller 
	 */
	addToCart( productId, elementCaller = null )
	{
		if ( ! productId )
		{
			console.error( "WMUWCCart | Invalid product ID on add to cart call", productId, elementCaller );
			return;
		}

		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/addToCart', {
			detail: {
				productId: productId,
				elementCaller: elementCaller,
			}
		} ) );

		if ( true === this.displayMiniCartOnAddProduct )
		{
			this.openMiniCart( {
				isLoading: true,
			} );
		}

		const formData = new FormData();
		formData.append( 'action', this.actionAdd );
		formData.append( '_ajax_nonce', this.nonce );
		formData.append( 'product_id', productId );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					window.dispatchEvent( new CustomEvent( 'wmuwc/addedToCart', {
						detail: {
							productId: productId,
							elementCaller: elementCaller,
							responseData: data,
						}
					} ) );

					if ( true === this.displayMiniCartOnAddProduct && data.data && data.data.miniCartRender )
					{
						this.setMiniCartContent( data.data.miniCartRender );
					}

					if ( data.data && data.data.itemCount !== undefined )
					{
						this.setItemCount( data.data.itemCount );
					}
				}
				else
				{

				}

				this.addToCartComplete( productId, elementCaller );
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.addToCartComplete( productId, elementCaller );
			} );
		
		this.isCalling = true;

		if ( elementCaller )
		{
			elementCaller.classList.add( this.addToCartButtonCallingClass );
			const ancestor = elementCaller.closest( this.addToCartButtonAncestorSelector );

			if ( ancestor )
			{
				ancestor.classList.add( this.addToCartButtonCallingClass );
			}
		}
	}

	/**
	 * 
	 * @param {Number} productId 
	 * @param {HTMLElement} elementCaller 
	 */
	addToCartComplete( productId, elementCaller = null )
	{
		this.isCalling = false;

		if ( elementCaller )
		{
			elementCaller.classList.remove( this.addToCartButtonCallingClass );
			elementCaller.classList.add( this.addToCartButtonAddedClass );
			const ancestor = elementCaller.closest( this.addToCartButtonAncestorSelector );

			if ( ancestor )
			{
				ancestor.classList.remove( this.addToCartButtonCallingClass );
				ancestor.classList.add( this.addToCartButtonAddedClass );
			}
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/addedToCartComplete', {
			detail: {
				productId: productId,
				elementCaller: elementCaller,
			}
		} ) );
		
		this.miniCartPopin.endLoading();
	}

	/**
	 * 
	 */
	getCartPopin()
	{
		if ( null === this.cartPopin )
		{
			this.cartPopin = wmuwcPopin.manager.get( this.cartPopinId, {
				closeOnClickOutside: false,
				displayMode: 'center',
				enableGlobalControls: false,
			} );
		}

		return this.cartPopin;
	}

	/**
	 * 
	 * @param {Event} event
	 */
	onAddToCartClick( event )
	{
		const elementCaller = ( event.target && event.target.classList.contains( this.addToCartButtonCheckClass ) )
			? event.target
			: ( event.target ) ? event.target.closest( `.${this.addToCartButtonCheckClass}` ) : null;
		
		if ( ! elementCaller )
		{
			console.error( "WMUWCCart | Can't find correct target on add to cart click call", event );
		}
		else
		{
			event.preventDefault();
			this.addToCart( elementCaller.getAttribute( 'data-product_id' ), elementCaller );
			event.stopPropagation();
		}
		
		return false;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onOpenCartClick( event )
	{
		event.preventDefault();
		
		if ( null === this.miniCartPopin )
		{
			this.miniCartPopin = wmuwcPopin.manager.get( this.miniCartPopinId );
		}

		if ( true === this.miniCartPopin.isOpen )
		{
			return;
		}

		this.openMiniCart();
		
		/**
		 * A terme mettre peut-être un système en place plus complexe pour "deviner" si faut faire un call d'update
		 * dans le cas de l'ouverture du panier. Pour le moment on va se contenter de checker si la popin est déjà
		 * remplie.
		 */
		if ( ! this.miniCartPopin.getContent() )
		{
			this.update( true );
		}
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onQuantityChange( event )
	{
		this.setUpdateTimeout();
		this.updatedFormElement = event.target.closest( this.cartFormSelector );
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onRemoveFromCartClick( event )
	{
		const elementCaller = ( event.target && event.target.classList.contains( this.removeFromCartButtonClassCheck ) )
			? event.target
			: ( event.target ) ? event.target.closest( `.${this.removeFromCartButtonClassCheck}` ) : null;
		
		if ( ! elementCaller )
		{
			console.error( "WMUWCCart | Can't find correct target on remove from cart click call", event );
		}
		else
		{
			event.preventDefault();
			this.removeFromCart( elementCaller.getAttribute( 'data-cart_item_key' ), elementCaller );
		}
		
		return false;
	}

	/**
	 * 
	 * @param {Event} event 
	 */
	onSingleAddToCartFormSubmit( event )
	{
		event.preventDefault();
		this.singleAddToCartFormSubmit();
		return false;
	}

	/**
	 * 
	 * @param {Object} args 
	 */
	openMiniCart( args = {} )
	{
		if ( null === this.miniCartPopin )
		{
			this.miniCartPopin = wmuwcPopin.manager.get( this.miniCartPopinId );
		}

		this.miniCartPopin.open();

		if ( args.isLoading )
		{
			this.miniCartPopin.startLoading();
		}
	}

	/**
	 * 
	 * @return Boolean
	 */
	isMiniCartOpen()
	{
		if ( null === this.miniCartPopin )
		{
			this.miniCartPopin = wmuwcPopin.manager.get( this.miniCartPopinId );
		}

		return this.miniCartPopin.isOpen;
	}

	/**
	 * 
	 * @param {String} cartItemKey 
	 * @param {HTMLElement} elementCaller 
	 */
	removeFromCart( cartItemKey, elementCaller = null )
	{
		if ( ! cartItemKey )
		{
			console.error( "WMUWCCart | Invalid cart item key on remove from cart call", cartItemKey, elementCaller );
			return;
		}

		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/removeFromCart', {
			detail: {
				cartItemKey: cartItemKey,
				elementCaller: elementCaller,
			}
		} ) );

		if ( this.miniCartPopin )
		{
			this.miniCartPopin.startLoading();
		}

		if ( this.isCartPage )
		{
			const popin = this.getCartPopin();
			popin.open();
			popin.startLoading( '' );
		}

		const formData = new FormData();
		formData.append( 'action', this.actionRemove );
		formData.append( '_ajax_nonce', this.nonce );
		formData.append( 'is_cart_page', this.isCartPage );
		formData.append( 'cart_item_key', cartItemKey );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					window.dispatchEvent( new CustomEvent( 'wmuwc/removedFromCart', {
						detail: {
							cartItemKey: cartItemKey,
							elementCaller: elementCaller,
							responseData: data,
						}
					} ) );

					if ( data.data && data.data.itemCount !== undefined )
					{
						this.setItemCount( data.data.itemCount );
					}

					if ( this.miniCartPopin && data.data && data.data.miniCartRender )
					{
						this.setMiniCartContent( data.data.miniCartRender );
					}

					if ( this.isCartPage && data.data && data.data.cartRender )
					{
						this.setCartContent( data.data.cartRender );
					}
				}
				else
				{

				}

				this.removeFromCartComplete( cartItemKey, elementCaller );
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.removeFromCartComplete( cartItemKey, elementCaller );
			} );
		
		this.isCalling = true;
	}

	/**
	 * 
	 * @param {String} cartItemKey 
	 * @param {HTMLElement} elementCaller 
	 */
	removeFromCartComplete( cartItemKey, elementCaller = null )
	{
		this.isCalling = false;

		window.dispatchEvent( new CustomEvent( 'wmuwc/removeFromCartComplete', {
			detail: {
				cartItemKey: cartItemKey,
				elementCaller: elementCaller,
			}
		} ) );

		if ( this.miniCartPopin )
		{
			this.miniCartPopin.endLoading();
		}

		if ( this.isCartPage )
		{
			const popin = this.getCartPopin();
			popin.endLoading();
			popin.close();
		}
	}

	/**
	 * 
	 * @param {String} content 
	 */
	setCartContent( content )
	{
		if ( null === this.domParser )
		{
			this.domParser = new DOMParser();
		}

		const tempDoc = this.domParser.parseFromString( content, "text/html" );
		const newCartFormElement = tempDoc.querySelector( this.cartFormSelector );
		const newCartTotalsElement = tempDoc.querySelector( '.cart-collaterals' );
		const cartFormElement = document.querySelector( '.wp-site-blocks form.woocommerce-cart-form' );
		const cartTotalsElement = document.querySelector( '.wp-site-blocks .cart-collaterals' );
		const newElements = [];

		if ( newCartFormElement && cartFormElement )
		{
			cartFormElement.parentNode.replaceChild( newCartFormElement, cartFormElement );
			newElements.push( newCartFormElement );
		}

		if ( newCartTotalsElement && cartTotalsElement )
		{
			cartTotalsElement.parentNode.replaceChild( newCartTotalsElement, cartTotalsElement );
			newElements.push( newCartTotalsElement );
		}

		if ( newElements.length > 0 )
		{
			window.dispatchEvent( new CustomEvent( 'wmu/newElements', {
				detail: {
					elements: newElements,
					from: this,
				}
			} ) );

			if ( newCartFormElement && cartFormElement )
			{
				this.initQuantityInputs( newCartFormElement );
				this.initRemoveFromCartButtons( newCartFormElement );
			}
		}
	}

	/**
	 * 
	 * @param {Number} count 
	 */
	setItemCount( count )
	{
		if ( this.itemCount === count ) return;

		this.openCartButtonList.forEach( ( button ) =>
		{
			let counter = button.querySelector( '.wmuwc-cart-counter' );

			if ( ! counter )
			{
				counter = document.createElement( 'span' );
				counter.classList.add( 'wmuwc-cart-counter' );
				button.appendChild( counter );
			}
			
			counter.innerHTML = count;

			if ( 0 === count )
			{
				counter.classList.add( 'empty' );
			}
			else
			{
				counter.classList.remove( 'empty' );
			}
		} );

		this.itemCount = count;
	}

	/**
	 * 
	 * @param {String} content 
	 */
	setMiniCartContent( content )
	{
		if ( null === this.miniCartPopin )
		{
			this.miniCartPopin = wmuwcPopin.manager.get( this.miniCartPopinId );
		}

		this.miniCartPopin.setContent( content );
		this.initQuantityInputs( this.miniCartPopin.contentElement );
		this.initRemoveFromCartButtons( this.miniCartPopin.contentElement );

		window.dispatchEvent( new CustomEvent( 'wmuwc/setMiniCartContent', {
			detail: {
				content: content,
			}
		} ) );
	}

	/**
	 * 
	 */
	clearUpdateTimeout()
	{
		if ( null !== this.updateTimeoutId )
		{
			clearTimeout( this.updateTimeoutId );
		}
	}

	/**
	 * 
	 */
	setUpdateTimeout()
	{
		this.clearUpdateTimeout();
		this.updateTimeoutId = setTimeout( () => this.update(), this.updateTimeoutDelay );
	}

	/**
	 * 
	 */
	singleAddToCartFormSubmit()
	{
		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		const formElement = document.querySelector( this.singleAddToCartFormSelector );

		if ( ! formElement )
		{
			return;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/singleAddToCartSubmit', {
			detail: {
				elementCaller: formElement,
			}
		} ) );

		if ( true === this.displayMiniCartOnAddProduct )
		{
			this.openMiniCart( {
				isLoading: true,
			} );
		}

		const formData = new FormData( formElement );
		formData.append( 'action', this.actionSingleAdd );
		formData.append( '_ajax_nonce', this.nonce );

		if ( ! formData.has( 'add-to-cart' ) )
		{
			const addToCartElement = formElement.querySelector( '[name="add-to-cart"]' );
			if ( addToCartElement )
			{
				formData.append( 'add-to-cart', addToCartElement.value );
			}
		}

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					window.dispatchEvent( new CustomEvent( 'wmuwc/singleAddedToCart', {
						detail: {
							elementCaller: formElement,
							responseData: data,
						}
					} ) );

					if ( data.data && data.data.itemCount !== undefined )
					{
						this.setItemCount( data.data.itemCount );
					}

					if ( true === this.displayMiniCartOnAddProduct && data.data && data.data.miniCartRender )
					{
						this.setMiniCartContent( data.data.miniCartRender );
					}
				}
				else
				{

				}

				if ( data.data && data.data.notices )
				{
					/**
					 * @todo Faire une fonction printNotices()
					 * En fonction de si le panier est ouvert ou non on les affichera différemment ?
					 */
					this.printNotices( data.data.notices );
				}

				this.singleAddToCartFormSubmitComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.singleAddToCartFormSubmitComplete();
			} );
		
		this.isCalling = true;
	}

	/**
	 * 
	 */
	singleAddToCartFormSubmitComplete()
	{
		this.isCalling = false;

		window.dispatchEvent( new CustomEvent( 'wmuwc/singleAddToCartSubmitComplete' ) );
		
		this.miniCartPopin.endLoading();
	}

	/**
	 * 
	 * @param {Object} notices 
	 */
	printNotices( notices )
	{
		if ( notices.errors )
		{
			if ( this.isMiniCartOpen() )
			{
				const contentElement = this.miniCartPopin.contentElement.querySelector( '.mini-cart-content' );

				if ( contentElement )
				{
					let noticesWrapperElement = contentElement.querySelector( '.wc-notices-wrapper' );

					if ( ! noticesWrapperElement )
					{
						noticesWrapperElement = document.createElement( 'div' );
						noticesWrapperElement.classList.add( 'wc-notices-wrapper', 'block-list' );

						if ( contentElement.hasChildNodes() )
						{
							contentElement.insertBefore( noticesWrapperElement, contentElement.firstChild );
						}
						else
						{
							contentElement.appendChild( noticesWrapperElement );
						}
					}

					noticesWrapperElement.innerHTML = notices.errors;
				}
			}
			else
			{
				/**
				 * @todo Ajouter la gestion des notices hors mini cart
				 */
			}
		}
	}

	/**
	 * @todo A terme mettre en place un système pour pouvoir update le miniCart ou le cart standard ou les 2
	 */
	update( forceUpdate = false )
	{
		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/updateCart' ) );

		if ( this.miniCartPopin )
		{
			this.miniCartPopin.startLoading();
		}

		if ( this.isCartPage )
		{
			const popin = this.getCartPopin();
			popin.open();
			popin.startLoading( '' );
		}

		const formElement = ( this.updatedFormElement ) ? this.updatedFormElement : document.querySelector( this.miniCartFormSelector );
		const formData = ( formElement ) ? new FormData( formElement ) : new FormData();
		formData.append( 'action', this.actionUpdate );
		if ( this.isCartPage && ! forceUpdate ) formData.append( 'is_cart_page', 1 );
		if ( forceUpdate ) formData.append( 'force_update', 1 );
		formData.append( '_ajax_nonce', this.nonce );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					window.dispatchEvent( new CustomEvent( 'wmuwc/updatedCart', {
						detail: {
							responseData: data,
						}
					} ) );

					if ( data.data && data.data.itemCount !== undefined )
					{
						this.setItemCount( data.data.itemCount );
					}

					if ( this.miniCartPopin && data.data && data.data.miniCartRender )
					{
						this.setMiniCartContent( data.data.miniCartRender );
					}

					if ( this.isCartPage && data.data && data.data.cartRender )
					{
						this.setCartContent( data.data.cartRender );
					}
				}
				else
				{

				}

				this.updateComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.updateComplete();
			} );
		
		this.isCalling = true;
	}

	/**
	 * 
	 */
	updateComplete()
	{
		this.isCalling = false;

		window.dispatchEvent( new CustomEvent( 'wmuwc/updateCartComplete' ) );
		
		if ( this.miniCartPopin )
		{
			this.miniCartPopin.endLoading();
		}

		if ( this.isCartPage )
		{
			const popin = this.getCartPopin();
			popin.endLoading();
			popin.close();
		}
	}

	/**
	 * 
	 */
	updateCount()
	{
		if ( true === this.isCalling )
		{
			/**
			 * @todo Faire une queue d'appel dans ce cas ?
			 */
			return;
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/updateCartCount' ) );

		const formData = new FormData();
		formData.append( 'action', this.actionUpdateCount );
		formData.append( '_ajax_nonce', this.nonce );

		const fetchInit = {
			method: 'POST',
			cache: 'no-cache',
			body: formData,
		};

		fetch( this.ajaxUrl, fetchInit )
			.then( ( response ) => response.json() )
			.then( ( data ) =>
			{
				if ( true === data.success )
				{
					window.dispatchEvent( new CustomEvent( 'wmuwc/updatedCartCount', {
						detail: {
							responseData: data,
						}
					} ) );

					if ( data.data && data.data.itemCount !== undefined )
					{
						this.setItemCount( data.data.itemCount );
					}
				}
				else
				{

				}

				this.updateCountComplete();
			} )
			.catch( ( error ) =>
			{
				console.error( error );
				this.updateCountComplete();
			} );
		
		// Cet appel ne concerne pas la popin donc on ne va pas bloquer les appels
		// this.isCalling = true;
	}

	/**
	 * 
	 */
	updateCountComplete()
	{
		// this.isCalling = false;

		window.dispatchEvent( new CustomEvent( 'wmuwc/updateCartCountComplete' ) );
	}

}

export default WMUWCCart;